import { fetchJson } from './client';

export type DirectUploadKind = 'photos' | 'drone-photos' | 'copc' | 'raw-pointcloud' | 'potree' | 'tiles';

export interface DirectPlanFile {
  relativePath: string;
  key?: string;
  multipart?: boolean;
  uploadId?: string;
  partSize?: number;
  partCount?: number;
  url?: string;
  contentType?: string;
  error?: string;
}

export interface DirectPlan {
  projectId: string;
  kind: DirectUploadKind;
  setId: string;
  tileMode: 'wrapped' | 'flat';
  partSize: number;
  files: DirectPlanFile[];
}

export const upload = {
  presign: (data: { projectId: string; filename: string; contentType: string; assetType: string }) =>
    fetchJson<{ uploadUrl: string; fileId: string; s3Key: string }>('/uploads/presign', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  complete: (fileId: string) =>
    fetchJson('/uploads/complete', { method: 'POST', body: JSON.stringify({ fileId }) }),
  abort: (fileId: string) =>
    fetchJson('/uploads/abort', { method: 'POST', body: JSON.stringify({ fileId }) }),
  syncProject: (projectId: string) =>
    fetchJson<{ success: boolean; linked: number }>(`/uploads/sync-project/${projectId}`, { method: 'POST' }),

  // ── Direct uploads into viewer-scanned prefixes (photos, point clouds, tiles) ──
  directPlan: (data: { projectId: string; kind: DirectUploadKind; files: Array<{ relativePath: string; size: number; contentType: string }>; setId?: string }) =>
    fetchJson<DirectPlan>('/uploads/direct/plan', { method: 'POST', body: JSON.stringify(data) }),
  directPartUrl: (key: string, uploadId: string, partNumber: number) =>
    fetchJson<{ url: string }>('/uploads/direct/part-url', { method: 'POST', body: JSON.stringify({ key, uploadId, partNumber }) }),
  directComplete: (key: string, uploadId: string, parts: Array<{ PartNumber: number; ETag: string }>) =>
    fetchJson<{ success: boolean; key: string; size: number | null }>('/uploads/direct/complete', { method: 'POST', body: JSON.stringify({ key, uploadId, parts }) }),
  directAbort: (key: string, uploadId: string) =>
    fetchJson('/uploads/direct/abort', { method: 'POST', body: JSON.stringify({ key, uploadId }) }),
  registerCopc: (projectId: string, key: string, name?: string) =>
    fetchJson<{ success: boolean; created: boolean; pointCloud: any }>('/uploads/direct/register-copc', { method: 'POST', body: JSON.stringify({ projectId, key, name }) }),
};
